'use strict';

import angular from 'angular';

import uiRouter from 'angular-ui-router';

import routing from './screenSaver.routes';

import list from './list';
import add from './add';
import edit from './edit';
import show from './show'

export default angular.module('updateServerApp.screensaver', [uiRouter, list, add, edit, show])
  .config(routing)
  .run(function ($rootScope) {
    'ngInject';

    $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
      if (next.name === 'logout' && current && current.name && !current.authenticate) {
        next.referrer = current.name;
      }
    });
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/screenSaver/index.js